// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"365":"e37712a8","373":"90730d92","634":"d7a3dbdb"}[chunkId] + ".chunk.css";
};